import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalContent,
  StyledIconClose,
  StyledTitle,
  StyledModalTransparent
} from './style';

import { Close } from '../../../../assets/images/index';

class Modal extends Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  renderModal = () => {
    const {
      className,
      clickCloseIcon,
      children,
      searchModal,
      center,
      title,
      tabletSize
    } = this.props;
    const modalContent = (
      <StyledModalContent
        searchModal={searchModal}
        center={center}
        className={className}
        tabletSize={tabletSize}
      >
        {clickCloseIcon && (
          <StyledIconClose onClick={clickCloseIcon} svg={Close} hover />
        )}
        <StyledTitle>{title}</StyledTitle>
        {children}
      </StyledModalContent>
    );

    return className === 'transparent' ? (
      <StyledModalTransparent className={className}>
        {modalContent}
      </StyledModalTransparent>
    ) : (
      <StyledModal tabletSize={tabletSize}>{modalContent}</StyledModal>
    );
  };

  render() {
    return this.renderModal();
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  clickCloseIcon: PropTypes.func
};

export default Modal;
